import { Button, DefaultDialog } from '@/ui_v3';
import { QUIZ_COPY_TEXT } from '../consts/text';
export type QuizCopiedChoice = 'view' | 'continue';
interface QuizCopiedDialogProps {
  onClose: (choice: QuizCopiedChoice) => void;
}

/**
 * 인증 왕복을 거쳐 돌아온 사람에게 복사 **결과**를 알린다.
 *
 * 토스트가 아니라 모달인 이유: 로그인·가입이라는 큰 단절 뒤라 사용자는 "내가 뭘 하려던 거였지"를
 * 복구해야 하는 상태다. 화면 구석의 8초짜리 알림으로는 놓친다.
 *
 * **고르게 하는 모달이 아니라 알리는 모달이다.** 복사는 이미 끝났으므로 그냥 닫아도 손해가 없다
 * (저장 위치를 고르게 하는 모달이었다면 닫는 순간 복사가 안 된 채 끝난다). 그래서 확인/취소가
 * 아니라 **다음 행동 두 개**를 준다 — 사본을 보러 가거나, 하던 풀이를 계속하거나.
 */
export const QuizCopiedDialog = ({
  onClose
}: QuizCopiedDialogProps) => <DefaultDialog size={'xs'} forceDrawerOnMobile onClose={() => onClose('continue')} header={{
  title: QUIZ_COPY_TEXT.copiedTitle
}} body={<p className={'px-lg text-body-lg-medium text-neutral'}>
        {QUIZ_COPY_TEXT.copiedDescription}
      </p>} footer={<div className={'flex gap-xs px-lg pb-lg'}>
        {/* 기본값은 '계속 풀기' 다 — 방금 풀이를 끝내지 않은 사용자를 덜컥 옮기지 않는다. */}
        <Button size={'lg'} variant={'outlined'} intent={'neutral'} className={'flex-1'} onClick={() => onClose('continue')}>
          {QUIZ_COPY_TEXT.keepPlaying}
        </Button>
        <Button size={'lg'} variant={'contained'} intent={'strong'} className={'flex-1'} onClick={() => onClose('view')}>
          {QUIZ_COPY_TEXT.viewCopied}
        </Button>
      </div>} data-sentry-element="DefaultDialog" data-sentry-component="QuizCopiedDialog" data-sentry-source-file="QuizCopiedDialog.tsx" />;